// PiecePreview Blockly のブロック種別・ツールボックス型
// 旧ビルダープレビュー（features/builder/canvas/blockly/type.ts）から復元。
// 現 builder/types には BlockType が無いため、ここに局所定義する。

export enum BlockType {
  MOTION_MOVE = "character_motion_move",
  MOTION_JUMP = "character_motion_jump",
  MOTION_TURN_LEFT = "character_motion_turn_left",
  MOTION_TURN_RIGHT = "character_motion_turn_right",
  CONTROLS_REPEAT_INTERNAL = "controls_repeat_internal",
  CONTROLS_WHILEUNTIL_COLOUR_INTERNAL = "controls_whileUntil_colour_internal",
  CONTROLS_IF_COLOUR_INTERNAL = "controls_if_colour_internal",
  COLOUR_PICKER_INTERNAL = "colour_picker_internal",
}

export interface ToolboxBlock {
  kind: string;
  type: string;
  [key: string]: unknown;
}

export interface ToolboxDefinition {
  kind: string;
  contents: {
    kind: string;
    toolboxitemid: string;
    custom?: string;
    expanded?: string;
    contents?: ToolboxBlock[];
  }[];
}
